import Axios from 'axios';
const baseURL = process.env.REACT_APP_API_URL;
const axiosInstance2 = Axios.create({
  baseURL: baseURL,
});
axiosInstance2.interceptors.request.use(
  function (config) {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

export default axiosInstance2;
